import { render } from "./collapsableWapper.vue?vue&type=template&id=3aceb0c5&scoped=true&ts=true"
import script from "./collapsableWapper.vue?vue&type=script&lang=ts"
export * from "./collapsableWapper.vue?vue&type=script&lang=ts"

import "./collapsableWapper.vue?vue&type=style&index=0&id=3aceb0c5&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aceb0c5"]])

export default __exports__